import React, {useState, useEffect} from 'react'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"

import all from './../../../UI/general/all.svg'
import all_white from './../../../UI/general/all_white.svg'
import collapse from './../../../UI/general/collapse.svg'
import collapse_white from './../../../UI/general/collapse_white.svg'

interface AmenitiesSidebarProps {
    amenitiesData: any,
    colorsData: any,
    handleamenitiesMenySelection: any,
    handleamenitiesFilter: any,
    handleMenuSelection: any,
    amenitiesFilterId: string,
    handleOpenAmenitiesSpin: any,
    handleCloseAmenitieSpin: any,
    isAmenities: boolean
}
declare const window: any;

const AmenitiesSidebar = ({
    amenitiesData, 
    colorsData, 
    handleamenitiesMenySelection, 
    handleamenitiesFilter,
    handleMenuSelection, 
    amenitiesFilterId,
    handleOpenAmenitiesSpin,
    handleCloseAmenitieSpin,
    isAmenities
}: AmenitiesSidebarProps) => {

    const [isCollapsed, setIsCollapsed] = useState(true)
    const [amenityIndex, setamenityIndex] = useState(-1)
    const [selectedamenityIndex, setSelectedamenityIndex] = useState(0)
    const [amenityOptionIndex, setamenityOptionIndex] = useState(-1)
    const [amenityOptionSelectedIndex, setamenityOptionSelectedIndex] = useState(-1)

    const [mouseOverSpin, setMouseOverSpin] = useState(false)
    const [spinOpened, setSpinOpened] = useState(false)
    const [spinData, setSpinData] = useState()

    useEffect(() => {
        setIsCollapsed(!isAmenities)
        if(!isAmenities){
            setIsCollapsed(true)
            setamenityIndex(-1)
            setSelectedamenityIndex(0)
            setamenityOptionIndex(-1)
            setamenityOptionSelectedIndex(-1)
            setMouseOverSpin(false)
            setSpinOpened(false)
        }
    }, [isAmenities])

    useEffect(() => {
        (async () => {
            var svgObj: any = document.querySelectorAll('#unselected-btn-amenities')
            if(svgObj){
                svgObj.forEach((obj: any) => {
                    var svgDoc = obj.contentDocument
                    if(svgDoc){
                        var paths = svgDoc.querySelectorAll('path')
                        paths.forEach((path: any) => {
                            path.setAttribute('fill',colorsData.main_text)
                        })
                    }
                })
            }
        })();
    }, [selectedamenityIndex, amenitiesFilterId, colorsData, spinOpened]);

    useEffect(() => {
        if(spinOpened){
            handleOpenAmenitiesSpin(spinData)
        }
        else if(!spinOpened && isAmenities){
            handleCloseAmenitieSpin()
        }
    }, [spinOpened,spinData, handleOpenAmenitiesSpin, handleCloseAmenitieSpin, isAmenities])
    
    return(
        <React.Fragment>
            <div 
                className={isCollapsed ? 'sidebar-collapse-btn-collapsed':'sidebar-collapse-btn'}
                onClick = {() => {setIsCollapsed(!isCollapsed)}}
            >
                <img src={collapsed} alt=""/>
            </div>
            <div className={isCollapsed ? 'sidebar-map-container-collapsed':'sidebar-map-container'}>
                <div
                    className="properties-close-btn"
                    onClick={() => {
                        handleCloseAmenitieSpin()
                        handleMenuSelection("")
                        setamenityIndex(-1)
                        setSelectedamenityIndex(0)
                        setamenityOptionIndex(-1)
                        setamenityOptionSelectedIndex(-1)
                    }}
                >
                    <img src={close} alt=""></img>
                </div>
                {
                    isAmenities ?
                    <div className='amenities-container'>
                    <div className='amenities-img-container'>
                        <img src={amenitiesData.icon} alt=""/>
                    </div>
                    <div className='amenities-name-container'>{"Amenidades".toUpperCase()}</div>
                    <div className='amenities-individual-container' id='amenities-individual-container'>
                        <div
                            className='individual-amenity'
                            style={{
                                backgroundColor: selectedamenityIndex === 0 && amenitiesFilterId === "" ? colorsData.main_buttons : amenityIndex === 0 ? colorsData.secondary_buttons: "transparent",
                                transition: "all 0.3s ease-in-out"
                            }}
                            onMouseEnter = {() => {setamenityIndex(0)}}
                            onMouseLeave = {() => {setamenityIndex(-1)}}
                            onClick = {() => {
                                handleamenitiesFilter("", 0)
                                setSelectedamenityIndex(0) 
                                setMouseOverSpin(false)
                                setSpinOpened(false)
                            }}
                        >
                            <div className='amenity-icon-name-container'>
                                <img src={selectedamenityIndex === 0 && amenitiesFilterId === "" ? all_white:all} alt=""/>
                                <div
                                    className='individual-amenity-name'
                                    style = {{
                                        color: selectedamenityIndex === 0 && amenitiesFilterId === "" ? '#fff': '#000'
                                    }}
                                >
                                    {"Ver todas"}
                                </div>
                            </div>
                        </div>
                        {
                            amenitiesData.menu.map((amenity: any, index: number) => 
                                <React.Fragment key={amenity.id + index}>
                                    <div
                                        key={amenity.id + index}
                                        className={'individual-amenity'}
                                        
                                    >
                                        <div 
                                            className='amenity-icon-name-container'
                                            style = {{
                                                backgroundColor: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? colorsData.main_buttons : amenityIndex === index + 1 ? colorsData.secondary_buttons: 'transparent'
                                            }}
                                            onMouseEnter = {() => {setamenityIndex(index + 1)}}
                                            onMouseLeave = {() => {setamenityIndex(-1)}}
                                            onClick = {() => {
                                                setSelectedamenityIndex(index + 1)
                                                selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? setSelectedamenityIndex(index + 1) : setamenityOptionSelectedIndex(-1)
                                                if(amenitiesData.menu.length === index + 1){
                                                    var amenitiesContainer = document.getElementById('amenities-individual-container')
                                                    amenitiesContainer?.scrollTo(0, document.body.scrollHeight)
                                                }
                                                setMouseOverSpin(false)
                                                setSpinOpened(false)
                                                handleamenitiesFilter(amenity.id, amenity.mainFrame)
                                            }}

                                            data-type={"AMENIDAD"}
                                            data-value={amenity.name.toUpperCase()}
                                        >
                                            {/*<object 
                                            type="image/svg+xml;utf8" 
                                            data={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+amenity.icon.replace(' ', '+')} 
                                            className="svg-img" id = {selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? 'selected-btn-amenities':'unselected-btn-amenities'}
                                            style={{
                                                filter: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? currentFilter: 'none'
                                            }}
                                        >.</object>*/}
                                        {
                                            <img src={(window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/")+amenity.icon.replace(' ', '+')} alt='' style={{filter: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? 'invert(1) brightness(100%)':'none'}}></img>
                                        }
                                            <div
                                                className='individual-amenity-name'
                                                style = {{
                                                    color: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? colorsData.secondary_text: colorsData.main_text 
                                                }}
                                                data-type={"AMENIDAD"}
                                                data-value={amenity.name.toUpperCase()}
                                            >
                                                {amenity.name}
                                            </div>
                                            {
                                                amenity.menu.length > 0 || amenity.spinLandscape !== null ? 
                                                <img data-type={"AMENIDAD"} data-value={amenity.name.toUpperCase()} src={selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? collapse_white:collapse} alt="" className={selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? "uncollapsed-btn-amenities":"collapsed-btn-amenities"}/>:null
                                            }
                                        </div>
                                        {
                                            <div 
                                                className={selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? 'amenity-selections-container':'amenity-selections-container-collapsed'}
                                                style={{
                                                    height: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? `${(amenity.menu.length * 4) + (amenity.spinLandscape !== null ? 4:0)}vh`:0,
                                                    opacity: selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id ? 1:0,
                                                    transition: 'all 0.5s ease-in-out'
                                                }}
                                            >
                                                                                                {
                                                amenity.menu.map((ameniteOption: any, indexamenity: number) => 
                                                <div 
                                                    className='amenity-individual-option' 
                                                    key={ameniteOption.name + indexamenity}
                                                    style={{
                                                        backgroundColor: amenityOptionIndex === indexamenity || amenityOptionSelectedIndex === indexamenity ? "#E0E0E0":'transparent'
                                                    }}
                                                    onMouseEnter = {() => {setamenityOptionIndex(indexamenity)}}
                                                    onMouseLeave = {() => {setamenityOptionIndex(-1)}}
                                                    onClick = {() => {
                                                        //setamenityOptionSelectedIndex(indexamenity)
                                                        setMouseOverSpin(false)
                                                        setSpinOpened(false)
                                                        handleamenitiesMenySelection(ameniteOption)
                                                    }}
                                                >
                                                    
                                                    <img src={ameniteOption.icon} alt={""}/>
                                                    <div 
                                                        className='amenity-individual-name'
                                                        style = {{
                                                            color: colorsData.main_text
                                                        }}
                                                    >
                                                        {ameniteOption.name}
                                                    </div>
                                                </div>
                                            )
                                        }
                                        {
                                            amenity.spinLandscape !== null ?
                                            <div 
                                                    className='amenity-individual-option' 
                                                    style={{
                                                        backgroundColor: spinOpened ? colorsData.main_buttons: mouseOverSpin ? "#E0E0E0":'transparent',
                                                    }}
                                                    onMouseEnter = {() => {setMouseOverSpin(true)}}
                                                    onMouseLeave = {() => {setMouseOverSpin(false)}}
                                                    onClick = {() => {
                                                        setSpinOpened(!spinOpened)
                                                        setSpinData(amenity.spinLandscape)
                                                    }}
                                                >
                                                    <img  
                                                    src={'./UI/amenities/recorrido.svg'} 
                                                    className="svg-img" 
                                                    id = {spinOpened ? 'selected-btn-amenities-spin':'unselected-btn-amenities'} alt=''
                                                    style={{
                                                        filter: spinOpened ? 'invert(1) brightness(100%)':'none'
                                                    }}
                                                    />
                                                    <div 
                                                        className='amenity-individual-name'
                                                        style = {{
                                                            color: spinOpened ? colorsData.secondary_text:colorsData.main_text
                                                        }}
                                                    >
                                                        Spin {amenity.spinLandscape.count_files === 25 ? '180º':'360º'}
                                                    </div>
                                                </div>:null
                                        }
                                            </div>
                                        }
                                    </div>
                                    {/*
                                        (selectedamenityIndex === index + 1 || amenitiesFilterId === amenity.id) && (amenity.menu.length > 0 || amenity.spinLandscape !== null) ?
                                        <hr className='hr-amenities' style={{animation: 'fadein 1s ease-in-out 1'}}/>:null
                                    */}
                                </React.Fragment>
                            )
                        }

                    </div>
                </div>:null
                }
            </div>
        </React.Fragment>
    )
}

export default AmenitiesSidebar